import cookieStore from './provider/js-cookie';
import inMemory from './provider/in-memory';
import type { CookieAttributes } from 'js-cookie';

export default {
  get(key: string): string | undefined {
    return cookieStore.get(key) || inMemory.get(key);
  },
  set(key: string, value: string, options: CookieAttributes = {}): void {
    cookieStore.set(key, value, options);
    inMemory.set(key, value);
  },
  remove(key: string, options: CookieAttributes = {}): void {
    cookieStore.remove(key, options);
    inMemory.remove(key);
  },
};
